<template>
  <ListItem :on-click="() => $emit('select', lead)">
    <div class="flex min-w-0 flex-1 gap-1 max-sm:flex-col sm:items-center sm:gap-4">
      <div class="min-w-0 sm:basis-[40%]">
        <p class="text-xs text-obsidian-500">{{ t('name') }}</p>
        <p class="truncate">{{ lead.firstName }} {{ lead.lastName }}</p>
      </div>
      <div class="min-w-0 sm:basis-[35%]">
        <p class="text-xs text-obsidian-500">{{ t('email') }}</p>
        <p class="truncate">{{ lead.email }}</p>
      </div>
      <div class="sm:basis-[25%] sm:text-right">
        <p class="text-xs text-obsidian-500">{{ t('createdAt') }}</p>
        <p>{{ formattedCreatedDate }}</p>
      </div>
    </div>
  </ListItem>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type { Lead } from '@carvia/ros-client-types';
import { useFormattedDate } from '@/hooks/use-formatted-date';
import { getDateTimeFormat } from '@/hooks/use-date-format';
import ListItem from '@/components/ListItem.vue';

const props = defineProps<{ lead: Lead }>();
defineEmits<{ (e: 'select', lead: Lead): void }>();

const { t } = useI18n();
const formattedCreatedDate = useFormattedDate(props.lead.createdDate, getDateTimeFormat());
</script>

<i18n lang="json">
{
  "en": {
    "name": "Name",
    "email": "Email",
    "createdAt": "Created"
  },
  "de": {
    "name": "Name",
    "email": "E-Mail",
    "createdAt": "Erstellt"
  },
  "es": {
    "name": "Nombre",
    "email": "Email",
    "createdAt": "Creado"
  }
}
</i18n>
